// 导入封装好的网络请求类工具
import service from "./axios";

// 获取考试流程
export const getExamProcess = data => {
  return service({
    url: "/apply/orderExam/getOrderExamList",
    method: "post",
    data,
    code: "v4"
  });
};

// 获取考试列表
export const getExamInfoList = (data, current, size) => {
  return service({
    url: "/apply/index/getExamInfoList",
    method: "post",
    params: {
      current,
      size
    },
    data,
    code: "v4"
  });
};

// 获取考试下的单位列表
export const getExamUnitList = data => {
  return service({
    url: "/apply/unitInfo/getUnitInfoByExamId",
    method: "post",
    data,
    code: "v4"
  });
};

// 获取考试下的岗位列表
export const getExamJobList = data => {
  return service({
    url: "/apply/jobInfo/getJobInfoList",
    method: "post",
    data,
    code: "v4"
  });
};

// 根据岗位获取报考字段
export const getApplyWordList = data => {
  return service({
    url: "/apply/fieldDetail/getFieldDetailList",
    method: "post",
    data,
    code: "v4"
  });
};

// 新增报名基本信息
export const addApplyBaseInfo = data => {
  return service({
    url: "/apply/applyDetail/add",
    method: "post",
    data,
    code: "v4"
  });
};

// 获取报名信息
export const getApplyInfo = data => {
  return service({
    url: "/apply/applyDetail/getApplyDetail",
    method: "post",
    data,
    code: "v4"
  });
};

// 获取个人报名字段信息
export const getApplyWordInfo = data => {
  return service({
    url: "/apply/examineeField/getPersonExamineeFieldList",
    method: "post",
    data,
    code: "v4"
  });
};

// 改变报考进程
export const changeApplyProcess = data => {
  return service({
    url: "/apply/applyDetail/updateCurrent",
    method: "post",
    data,
    code: "v4"
  });
};

// 获取个人报考信息
export const getPersonalExamList = data => {
  return service({
    url: "/apply/applyDetail/getPersonApplyDetailList",
    method: "post",
    data,
    code: "v4"
  });
};

// 获取审核结果 apply/applyDetail/getDeclareResult
export const getCheckStatus = data => {
  return service({
    url: "/apply/applyDetail/getDeclareResult",
    method: "post",
    data,
    code: "v4"
  });
};

// 获取付款码
export const getPayData = data => {
  return service({
    url: "/apply/wxpay/getReceivingCode",
    method: "post",
    params: data,
    code: "v4"
  });
};

// 查询缴费状态
export const getPayStatus = data => {
  return service({
    url: "/apply/wxpay/checkPaymentStatus",
    method: "post",
    params: data,
    code: "v4"
  });
};

// 查看准考证
export const getExamLimit = data => {
  return service({
    url: "/apply/applyDetail/getZkz?id=" + data,
    method: "get",
    code: "v4"
  });
};

// 判断报考岗位与已报考是否冲突
export const checkJobTime = data => {
  return service({
    url: "/apply/applyDetail/getEnrollPersonalComparison",
    method: "post",
    data,
    code: "v4"
  });
};

// 提交报考信息
export const submitBaseInfo = data => {
  return service({
    url: "/apply/applyDetail/addBasicInfo",
    method: "post",
    data,
    code: "v4"
  });
};

// 提交证件资料
export const submitCertificate = data => {
  return service({
    url: "/apply/applyDetail/addVoucheInfo",
    method: "post",
    data,
    code: "v4"
  });
};

// 提交教育资料
export const submitEducation = data => {
  return service({
    url: "/apply/applyDetail/addEducationInfo",
    method: "post",
    data,
    code: "v4"
  });
};

// 获取历史提交证件资料
export const getSubmitCertificate = data => {
  return service({
    url: "/apply/applyDetail/getVoucheInfo",
    method: "post",
    data,
    code: "v4"
  });
};

// 检测考生报名进度
export const checkApplyState = data => {
  return service({
    url: "/apply/applyDetail/checkApplyDetail",
    method: "post",
    data,
    code: "v4"
  });
};

// 修改审核状态
export const editApplyStatus = data => {
  return service({
    url: "/apply/applyDetail/commit",
    method: "post",
    data,
    code: "v4"
  });
};

// 判断是否在缴费时间内
export const checkPayDate = data => {
  return service({
    url: "/apply/applyDetail/isCanPay",
    method: "post",
    data,
    code: "v4"
  });
};

// 判断是否在打印准考证时间内
export const checkPrintDate = data => {
  return service({
    url: "/apply/applyDetail/isCanPrint",
    method: "post",
    data,
    code: "v4"
  });
};



// WEBPACK FOOTER //
// ./src/api/apply.js